import { render, staticRenderFns } from "./painting.vue?vue&type=template&id=453413a1&scoped=true"
import script from "./painting.vue?vue&type=script&lang=js"
export * from "./painting.vue?vue&type=script&lang=js"
import style0 from "./painting.vue?vue&type=style&index=0&id=453413a1&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453413a1",
  null
  
)

export default component.exports